import config from '../config';
import { authHeader, customFetch, handleResponse, commonRequestOptions } from '../helpers';

const endpointPath = config.api.API_URL + '/oidc_client_scope_map';

export const oidcClientScopeMapService = {
  getByClientId,
};

function getByClientId(id, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/client_id/${id}`, requestOptions, signal).then(
    handleResponse
  );
}
